<template>

  <div class="position-relative">
    <div class="index-team-wrapper">
      <div class="d-md-flex ">
        <div class="left-info d-flex align-items-center">
          <div class="content">
            <div class="index-about-title">{{ title2 }}</div>
            <div class="index-about-description">{{ description2 }}</div>
          </div>
          <div class="bottom-bar"></div>
        </div>
        <div class="left-button d-md-flex align-items-center">
          <div class="label">{{ buttonPlaceholder1 }}</div>
          <router-link :to="{name: 'TeamView' }">
            <CircleButton :theme="'solid-blue'"/>
          </router-link>
        </div>
        <div class="ms-auto  pt-5 carousel-container">
          <Carousel :breakpoints="breakpoints" v-bind="settings">
            <Slide v-for="specialist in specialists" :key="specialist.id">
              <!-- Ensure `id` exists and matches the structure -->
              <router-link :to="{name: 'OneDoctorView', params: {id: specialist.id}}">
                <OneSpecialistThumbnail
                    :category="specialist.content.category.value"
                    :img-src="specialist.content.imageUrl[0]"
                    :title="specialist.content.name"
                />
              </router-link>
            </Slide>

          </Carousel>
        </div>
      </div>
    </div>
  </div>


</template>
<script>

import CircleButton from "@/components/Common/Buttons/CircleButton.vue";
import {defineComponent} from 'vue'
import {Carousel, Slide} from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'
import OneSpecialistThumbnail from "@/components/Components/OneSpecialistThumbnail/OneSpecialistThumbnail.vue";

export default defineComponent({
  name: 'IndexTeamComponent',
  components: {OneSpecialistThumbnail, CircleButton, Carousel, Slide},
  props: {
    title1: {
      type: String
    },
    title2: {
      type: String
    },
    description1: {
      type: String
    },
    description2: {
      type: String
    },
    buttonPlaceholder1: {
      type: String
    },
    buttonPlaceholder2: {
      type: String
    },
    specialists: {
      type: Array,
      required: true,
    }
  },
  data: () => ({
    // carousel settings
    settings: {
      itemsToShow: 1.7,
      snapAlign: 'start',

    },
    // breakpoints are mobile first
    // any settings not specified will fallback to the carousel settings
    breakpoints: {
      // 700px and up
      // 700: {
      //   itemsToShow: 2.8,
      //   snapAlign: 'start',
      //   slideWidth: 240,
      // },
      // 1024 and up
      1024: {
        itemsToShow: 1.7,
        snapAlign: 'start',
      },
      // 10
      1201: {
        itemsToShow: 2.2,
        snapAlign: 'start',
      },
      // 1024 and up
      1920: {
        itemsToShow: 3.3,
        snapAlign: 'start',
      },
    },
  }),
  mounted() {
    console.log(this.specialists); // Ensure this logs the correct data
  },
})
</script>

<style lang="scss">
.carousel__slide {
  width: 300px; /* Set the width of each slide */
  flex-shrink: 0; /* Prevent the slide from shrinking */

  @media screen and (min-width: 768px) {
    .news-thumbnail {
      .thumbnail-container {
        width: 310px;
        padding-right: 10px;
      }
    }
  }
  @media screen and (min-width: 1024px) {
    .news-thumbnail {
      .thumbnail-container {
        width: 350px;
        padding-right: 10px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.carousel-container {
  width: 100%;
  @media screen and (min-width: 823px) {
    width: 600px;
  }
  @media screen and (min-width: 1200px) {
    width: 800px;
  }
  @media screen and (min-width: 1920px) {
    width: 1200px;
  }
}

.index-team-wrapper {
  color: $color-white;
  padding-bottom: 50px;

  .index-about-title {
    font-size: $title-h4;
    line-height: $title-h4;
  }

  .index-about-description {
    margin-top: $spacing-2;
    font-size: $paragraph-2;
  }

  .index-about-subtitle {
    font-size: $subtitle-1;
    width: 40%;
    line-height: 20px;
    text-align: right;
  }

  .left-button {
    display: none;
  }
}

.index-about-photo-wrapper {
  margin-top: -150px;
  color: $color-dark-brown;
  position: relative;
  padding: 50px 0 0;


  .index-about-subtitle {
    font-size: $subtitle-1;
    width: 45%;
    line-height: 20px;
    text-align: right;
  }
}

.left-info {
  background: $color-cta-main;
  width: 100%;
  padding: 0px 20px 50px 20px;

  .content {
    width: 450px;
  }
}


.bottom-bar {
  display: none;
}

@media screen and (min-width: 768px) {

  .doctors-carousel {
    transform: translateY(-50%);
  }
  .index-team-wrapper {

    .left-info {
      position: absolute;
      padding: 60px;
    }

    .index-about-title {
      font-size: $title-h1;
      width: 100%;
      line-height: 40px;
    }

    .index-about-description {
      font-size: $paragraph-1;
      line-height: $paragraph_1;
      width: 80%;
    }

    .index-about-subtitle {
      width: 20%;
    }
  }
  .index-about-photo-wrapper {
    padding: 90px 0;
    position: relative;
    width: 100%;
    height: 100%;
    margin-top: -500px;

    .index-about-subtitle {
      width: 22%;
    }
  }
  .left-button {
    display: block;
    width: 100%;
    position: absolute;
    padding: 0px 60px 60px 150px;
    bottom: 0;

    .label {
      width: 100px;
      margin-right: 20px;
      text-align: right;
      font-family: $font-semi-bold;
      color: $color-dark-brown;
    }
  }

  .bottom-bar {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background: $color-cta-main;
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 50px;
    transform: translateY(99%);
  }
}

</style>